import { IconTrigger } from '@components/icons/trigger';
import { StatusIndicator } from '@components/status-indicator';
import { useScopedTranslate } from '@locale/translate';

import { User } from 'api/users/requests';

import { Assignees } from './assignees';

type TriggerMethodIndicatorProps = {
  isAutomatic?: boolean;
  assignees?: User[];
};

export const TriggerMethodIndicator = ({ isAutomatic, assignees }: TriggerMethodIndicatorProps) => {
  const { t } = useScopedTranslate(locale);

  if (!isAutomatic) {
    return <Assignees assignees={assignees} label={t('manual')} />;
  }

  return <StatusIndicator variant="notStarted" icon={<IconTrigger />} label={t('automatic')} />;
};

const locale = {
  en: {
    automatic: 'Automatic trigger',
    manual: 'Manual action',
  },
};
